import React, { useContext } from "react"
import {
  RefinementList,
  Hits,
  Panel,
  Pagination,
  HitsPerPage,
  ClearRefinements,
  connectStats,
  Index,
  connectRefinementList,
} from "react-instantsearch-dom"
import { Row, Col, Accordion, Card } from "react-bootstrap"
import { Link } from "gatsby"
import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
import AccordionContext from "react-bootstrap/AccordionContext"

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext)

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  )

  const isCurrentEventKey = currentEventKey === eventKey

  return isCurrentEventKey ? (
    <div
      className="filterheader card-header accord-open"
      style={{ backgroundColor: "#ffffff" }}
      onClick={decoratedOnClick}
    >
      {children}
    </div>
  ) : (
    <div
      className="filterheader card-header accord-closed"
      onClick={decoratedOnClick}
    >
      {children}
    </div>
  )
}

const algoliaIndex = "production_PROJECTS"

const CustomStats = connectStats(
  ({ processingTimeMS, nbHits, onCountChange }) => {
    if (onCountChange) onCountChange(nbHits)
    return <></>
  }
)

let facets = ["style", "type", "material", "use", "door Style", "color"]

const VirtualRefinementList = connectRefinementList(() => null)

const Hit = ({ hit }) => (
  <article>
    <Col key={hit.title} className="item portfolio-th">
      <Link className="_link" to={hit.slug}></Link>
      <figure
        className="project-thumb"
        style={{
          background: `url(${hit.imageUrl})`,
        }}
      ></figure>
      <div className="overlay overlaytext">
        <h2>{hit.title}</h2>
      </div>
    </Col>
  </article>
)

const ProjectsResults = ({
  onCountChange,
  hitComponent,
  showCategory,
  showSubCategory,
}) => {
  let hitComponentCurrent = hitComponent ? hitComponent : Hit
  return (
    <Row>
      <Index indexName={algoliaIndex}>
        <VirtualRefinementList attribute="category" />
        <VirtualRefinementList attribute={`sub Category`.replace(/ /g, "")} />
        <Col md={3} className="search-filters">
          <div className="projects-filterhead">FILTER PROJECTS</div>
          {showCategory && (
            <Accordion defaultActiveKey="0">
              <Card>
                <ContextAwareToggle
                  as={Card.Header}
                  variant="link"
                  eventKey="0"
                  className="filterheader"
                >
                  CATEGORY
                </ContextAwareToggle>

                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <RefinementList attribute="category" />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          )}

          {showSubCategory && (
            <Accordion defaultActiveKey="0">
              <Card>
                <ContextAwareToggle
                  as={Card.Header}
                  variant="link"
                  eventKey="0"
                  className="filterheader"
                >
                  SUB CATEGORY
                </ContextAwareToggle>

                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <RefinementList
                      attribute={`sub Category`.replace(/ /g, "")}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          )}

          {facets.map((facet, index) => {
            let evtKey = index + 1
            return (
              <Panel key={facet}>
                <Accordion>
                  <Card>
                    <ContextAwareToggle
                      as={Card.Header}
                      variant="link"
                      eventKey={`${evtKey}`}
                      className="filterheader"
                    >
                      {facet.toUpperCase()}
                    </ContextAwareToggle>

                    <Accordion.Collapse eventKey={`${evtKey}`}>
                      <Card.Body>
                        <RefinementList attribute={facet.replace(/ /g, "")} />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Panel>
            )
          })}
          <div>
            {showCategory ? (
              <ClearRefinements
                className="clearfilter"
                style={{ alignSelf: "center" }}
              />
            ) : (
              <ClearRefinements
                className="clearfilter"
                style={{ alignSelf: "center" }}
                transformItems={(items) =>
                  items.filter(({ attribute }) => attribute !== "category")
                }
              />
            )}
          </div>
        </Col>
        <Col md={9}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              alignSelf: "center",
            }}
          ></div>

          <Hits hitComponent={hitComponentCurrent} className="test" />
          <div style={{ marginLeft: "auto" }}>
            <CustomStats onCountChange={onCountChange} />
          </div>
          <div className="showcount" style={{ paddingLeft: "10px" }}>
            <HitsPerPage
              defaultRefinement={12}
              items={[
                { value: 12, label: "Show 12 " },
                { value: 50, label: "Show 50 " },
              ]}
            />
          </div>
          <br />
          <Pagination />
        </Col>
      </Index>
    </Row>
  )
}

ProjectsResults.defaultProps = {
  showCategory: true,
  showSubCategory: true,
}

export default connectStats(ProjectsResults)
